import { useTrackingEvent, useTrpcMutation, useTeam } from '@vrplatform/data';
import type { owner_statement_status_enum } from '@vrplatform/graphql';
import { useAutomationHistoryDrawer } from '../../../../hooks';

type Notification = 'now' | '2hrs' | 'disabled';

export function useStatementStatusMutation() {
  const [{ id: teamId }] = useTeam();

  const { open: openAutomationHistoryDrawer } = useAutomationHistoryDrawer();
  const track = useTrackingEvent();

  const { mutate, loading } = useTrpcMutation('publishOwnerStatement', {
    invalidateQueryKeys: ['ownerStatements', 'ownerStatementTemplates'],
  });

  const updateStatus = async (
    data: {
      ids: string[];
      status: owner_statement_status_enum;
    },
    notification: Notification,
    message?: string
  ) => {
    return mutate({
      teamId,
      statements: data.ids.map((id) => ({ id })),
      status: data.status,
      notification,
      message,
    }).then((x) => {
      Promise.all(
        data.ids.map((ownerStatementId) =>
          track('owner_statement_status_changed', {
            ownerStatementId,
            status: data.status,
          })
        )
      ).catch((e) => {
        console.error(e);
      });

      const syncId = x.task?.syncId;

      if (syncId) openAutomationHistoryDrawer(syncId);
      return { ok: true, task: x.task };
    });
  };

  return {
    updateStatus,
    loading,
  };
}
